import 'setimmediate';

import winston from 'winston';

const enumerateErrorFormat = winston.format((info) => {
  if (info.message instanceof Error) {
    info.message = Object.assign(
      {
        message: info.message.message,
        stack: info.message.stack,
      },
      info.message
    );
  }

  if (info instanceof Error) {
    return Object.assign(
      {
        message: info.message,
        stack: info.stack,
      },
      info
    );
  }

  return info;
});

const logger = winston.createLogger({
  level: 'silly',
  exitOnError: false,
  format: winston.format.combine(enumerateErrorFormat(), winston.format.json()),
  transports: [new winston.transports.Console()],
});

export default logger;
